import { createDayjsDate } from '@/utils/dayjs'

export const isInRenewOrderDate = (
  { packagePlan, packageExpiredAt },
  { unit, value }
) => {
  const packagePlanNotFree = packagePlan !== 'free'
  const canRenewPackage = createDayjsDate(packageExpiredAt).diff(createDayjsDate(), unit, true) <= value
  return packagePlanNotFree && canRenewPackage
}

export const isInRenewPremiumIdDate = (
  { premiumIdExpiredAt },
  { unit, value }

) => {
  const canRenewPremiumId = createDayjsDate(premiumIdExpiredAt).diff(createDayjsDate(), unit, true) <= value
  return canRenewPremiumId
}

export const isBuyNewPremiumIdByNewAccount = ({ premiumId }) => premiumId === undefined

export const isInRenewOaChatDate = (
  { oaChatExpiredAt },
  { unit, value }

) => {
  const canRenewOaChat = createDayjsDate(oaChatExpiredAt).diff(createDayjsDate(), unit, true) <= value
  return canRenewOaChat
}

export const isBuyNewOaChatByNewAccount = ({ oaChat }) => oaChat === undefined

export const mapOrdersFilterFee = (orders) => orders.map(({ orderItems, ...filterOrder }) => ({
  ...filterOrder,
  orderItems: orderItems.filter(({ productType }) => productType !== 'fee')
}))

// eslint-disable-next-line max-len
export const isUpdatedProfile = (Account) => Account.isProfileUpdate && !!Account.displayName && !!Account.emailQuotation

export const getProductName = (orderItem) => {
  if (orderItem.productType === 'message') {
    return `${String(orderItem.packagePlan).toUpperCase()} : Additional Messages ${
      orderItem.unitPrice
    } Baht/Message`
  }

  return orderItem.productName
}
